export default {
  1: 'Audiencia pendiente',
  5: 'Pagada',
  9: 'Audiencia vencida',
  10: 'Multa vigente',
  15: 'Multa archivada',
  19: 'Multa vencida',
  25: 'Multa notificada',
}
